import React from 'react';
import PropTypes from 'prop-types';
import ChevronDownIcon from 'assets/icons/ChevronDown';
import ChevronUpIcon from 'assets/icons/ChevronUp';
import shouldUpdate from 'recompose/shouldUpdate';
import styled from 'styled-components';
import theme from 'theme/theme';
import translate from 'components/hoc/translate';
import { SORT_ASC, SORT_DESC } from 'store/actions/types';

const StyledColumn = styled.th`
    position: relative;
    padding: 0;
    width: ${ (props) => {
        return props.width;
    } };
    text-align: ${ (props) => {
        return props.align;
    } };
    white-space: nowrap;
    text-overflow: ellipsis;
    color: ${ theme.table.head.color };
    border-bottom: 1px solid ${ theme.table.head.border };

    &:first-of-type {
        padding-left: 12px;
    }
`;

const StyledLabel = styled.div`
    font-size: 14px;
    font-weight: 500;
    text-transform: uppercase;
`;

const StyledButton = styled.button`
    min-width: 200px;
    display: flex;
    align-items: center;
    border: none;
    text-transform: uppercase;
    cursor: pointer;
    background-color: transparent;

    ${ (props) => {
        const { align } = props;

        if (align === 'left') {
            return 'padding: 5px 5px 5px 0';
        }

        return 'padding: 5px';
    } };
`;

const StyledDirectionWrapper = styled.div`
    margin-left: 10px;
    display: flex;
    align-items: center;
`;

const SortDirectionIcon = (props) => {
    const { currentField, direction } = props;

    let showChevronDown = true,
        showChevronUp = true;

    if (currentField) {
        switch (direction) {
            case SORT_ASC:
                showChevronDown = true;
                showChevronUp = false;
                break;
            case SORT_DESC:
                showChevronDown = false;
                showChevronUp = true;
                break;
            default:
                break;
        }
    }

    return (
        <StyledDirectionWrapper>
            { showChevronUp &&
                <ChevronUpIcon
                    height='16'
                    width='16'
                />
            }

            { showChevronDown &&
                <ChevronDownIcon
                    height='16'
                    width='16'
                />
            }
        </StyledDirectionWrapper>
    );
};

SortDirectionIcon.propTypes = {
    currentField: PropTypes.bool.isRequired,
    direction: PropTypes.string.isRequired,
};

const TableHeaderCell = (props) => {
    const {
        align,
        currentSort,
        field: {
            props: {
                label,
                source,
            },
        },
        updateSort,
        sortable,
        translate,
        width,
    } = props;

    if (sortable) {
        return (
            <StyledColumn
                align={ align }
                width={ width }
            >
                <StyledButton
                    align={ align }
                    data-sort={ source }
                    onClick={ updateSort }
                >
                    { label &&
                        <StyledLabel>
                            { translate(label) }
                        </StyledLabel>
                    }

                    <SortDirectionIcon
                        currentField={ currentSort.field === source }
                        direction={ currentSort.order }
                    />
                </StyledButton>
            </StyledColumn>
        );
    }

    // The Column is not sortable.
    return (
        <StyledColumn
            align={ align }
            width={ width }
        >
            { label &&
                <StyledLabel>
                    { translate(label) }
                </StyledLabel>
            }
        </StyledColumn>
    );
};

TableHeaderCell.defaultProps = {
    align: 'left',
    sortable: false,
};

TableHeaderCell.propTypes = {
    align: PropTypes.string,
    currentSort: PropTypes.shape({
        field: PropTypes.string,
        order: PropTypes.string,
    }),
    field: PropTypes.element,
    sortable: PropTypes.bool,
    translate: PropTypes.func.isRequired,
    updateSort: PropTypes.func.isRequired,
    width: PropTypes.string.isRequired,
};

const PureTableHeaderCell = shouldUpdate((props, nextProps) => {
    return props.isSorting !== nextProps.isSorting
    || (nextProps.isSorting && props.currentSort.order !== nextProps.currentSort.order);
}
)(TableHeaderCell);

export default translate(PureTableHeaderCell);



// WEBPACK FOOTER //
// ./src/components/table/TableHeaderCell.js